import React from "react";
import "./exp.css";
import { BsPatchCheckFill } from "react-icons/bs";

const Exp = () => {
  return (
    <section id="experience">
      <h5>What Experience I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience_container">
        <div className="experience-frontend">
          <div className="experience_content">
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
                <h4>Software Engineer</h4>
                <small className="text-light">Red & White Multimedia Education</small>
                <br/>
                <small className="text-light">Apr 2024 - present</small>
              </div>
            </article>

          </div>
        </div>

        {/* backend detials now  */}

        <div className="experience_backend">
          <div className="experience_content">
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
                <h4>Frontend Engineer</h4>
                <small className="text-light">muVerity Cunsultancy Services</small>
                <br/>
                <small className="text-light">May 2022 - Apr 2024</small>
              </div>
            </article>

           
            {/* <article className='experience_details'>
  <BsPatchCheckFill className='experience_details-icon' />
  <div>
    <h4>Python</h4>
  <small className='text-light'>Intermediate</small>
  </div>
</article> */}
          </div>
        </div>
      </div>


    </section>
  );
};

export default Exp;
